import React from 'react';
import { View } from 'react-native';
import { ThemedView, ThemedText } from '@app/theme';
import {addCommasToNumber} from "@app/utils";
import {isMobileView} from "@sharedComponents/stack/utils";


const ExistingCreditLimitTooltip: React.FC<any> = ({ onClose }) => (
  <ThemedView
    position="absolute"
    top={26}
    right={0}
    left={-40}
    backgroundColor="white"
    padding={"md"}
    borderColor={"border-primary"}
    borderWidth={1}
    borderRadius={"sm"}
    zIndex={9999}
    width={200}
    shadowColor="black"
    shadowOffset={{ width: 0, height: 2 }}
    shadowOpacity={0.25}
    shadowRadius={4}
    elevation={10}
    style={{
      shadowColor: 'rgba(0, 0, 0, 0.17)',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 1,
      shadowRadius: 17,
      backgroundColor: 'white',
    }}
  >
    <ThemedText variant="b4r" color="text-primary">
      Existing credit limit is based on the latest value of your pledged mutual funds.
    </ThemedText>
    {/* Arrow pointing up to the info icon */}
    <View style={{
      position: 'absolute',
      top: -8,
      right: 0,
      left: 40,
      width: 0,
      height: 0,
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderTopWidth: 0,
      borderRightWidth: 8,
      borderBottomWidth: 8,
      borderLeftWidth: 8,
      borderTopColor: 'white',
      borderRightColor: 'transparent',
      borderBottomColor: 'white',
      borderLeftColor: 'transparent',
    }}/>
  </ThemedView>
);

export default ExistingCreditLimitTooltip;